import React, {useState, useContext} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon"
import arrowRightLargeTokens from "@amzn/meridian-tokens/base/icon/arrow-right-large"
import {isValidEntry, MAC_MASK, PATTERNS} from "../util/Validations";
import Input from "@amzn/meridian/input";
import {GlobalStateContext} from "../global/context/GlobalStateContext";

const EditMacAddressModal = (props) => {

    const {open, setOpen, selectedMac, setSelectedMac, dispatch, stateValues, assetType} = props;
    const [newMac, setNewMac] = useState("");
    const {showWarning} = useContext(GlobalStateContext);
    const {formatMessage} = props.intl;

    const [macErr, setMacErr] = useState(true)
    const { showCustomAlert } = useContext(GlobalStateContext);

    const onCloseModal = () => {
        setOpen(false);
        setMacErr(true);
        setSelectedMac("");
        resetInputState();
    }

    const onClickConfirm = async () => {
        showWarning(formatMessage({id: "device.editWarning"}), () => {
            onCloseModal();
            dispatch({
                type: 'UPDATE_DEVICE_MAC',
                data: {
                    dispatcher: dispatch,
                    stateValues: {
                        ...stateValues,
                        mac: newMac
                    },
                    showCustomAlert: showCustomAlert,
                    mac: selectedMac,
                    assetType: assetType
                }
            });
            getData();
        });
    };

    function resetInputState() {
        setNewMac("");
    }

    const getData = () => {
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: props.dispatch}});
    }

    return (
        <Modal
            title={formatMessage({id: "device.edit_device_mac_modal"})}
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    <FormattedMessage id="modal.confirmmacedit"
                      defaultMessage="Please enter new mac address for the following device:"/>
                </Text>
                <Row>
                    <Text type={"h300"}> {selectedMac} </Text>
                    <Icon tokens={arrowRightLargeTokens}/>
                    <Input id="mac-input"
                           value={newMac}
                           onChange={(val) => {
                               setNewMac(val)
                               setMacErr(!isValidEntry(val, PATTERNS.MAC))
                           }}
                           mask={MAC_MASK}
                           error={macErr}
                    />
                </Row>
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary" size="medium" disabled={macErr}
                            onClick={() => onClickConfirm()}>
                        <FormattedMessage id="modal.confirm"
                                          defaultMessage="Confirm"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(EditMacAddressModal);



// WEBPACK FOOTER //
// ./src/components/commonui/EditMacAddressModal.js